module.exports = "/_next/static/images/800163908109a39fde74e81ea3a7f85e-icon-app.svg.webp";